import { useQuery } from "@apollo/client";
import { GET_PAGINATED_CAR_PART_LIST } from '../query';
import { clientV2 } from "../../../common";

interface IGetCarPartListDataProps {
    children: (carList, loading, error, fetchMore, refetch) => JSX.Element;
}

export const GetPaginatedCarPartList = (props: IGetCarPartListDataProps) => {
    const {
        data,
        loading, 
        error, 
        fetchMore, 
        refetch
    } = useQuery(GET_PAGINATED_CAR_PART_LIST, {
            client: clientV2, 
            fetchPolicy: 'cache-first',
            variables: {
                page: 1,
                perPage: 20,
                search: ''
            }
        });
        
    if (loading || error) return null;
    return props.children(data?.getCarPartsPaginated, loading, error, fetchMore, refetch);
};